"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggerConf = exports.Logger = exports.initCustomLogger = void 0;
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'groups' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 111 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'groups' });
    }
    ;
    /**
    * @typedef {Object} clubPostClickOnOptionsParams
    * @property {GUID} club_id - null
    * @property {GUID} clubId - null
    * @property {string} container - null
    * @property {string} post_id - null
    * @property {string} postId - null
    * @property {string} userClass - null
    **/
    /**
     * Name: Club post -> click on options. Evid: 83.
    
    
     * club_id - Type: guid.
     *
     * clubId - Type: guid.
     *
     * container - Type: string.
     *
     * post_id - Type: string.
     *
     * postId - Type: string.
     *
     * userClass - Type: string.
     * @param {clubPostClickOnOptionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clubPostClickOnOptions = function (params) {
        return this.bi.log(__assign({ evid: 83 }, params));
    };
    /**
    * @typedef {Object} groupSettingsSaveParams
    * @property {boolean} display_cover - t/f
    * @property {string} edit_tab - 'discussions'/'media'/'members'/'about'
    * @property {GUID} group_id - id
    * @property {boolean} member_toggle - bool
    * @property {string} origin - save_button
    * @property {boolean} show_media - bool
    * @property {boolean} show_members - bool
    * @property {string} tabName - 'details'/'tabs'/'permissions'
    * @property {string} type - 'private'/'public'/'secret'
    * @property {string} userEntry - bizmgr/site/members_area/oneapp
    * @property {boolean} withPhoto - t/f
    **/
    /**
     * Name: Group -> group settings save. Evid: 10.
     * Event description: saves new settings.
    
     * display_cover - Type: bool. Desc: t/f
     *
     * edit_tab - Type: string. Desc: 'discussions'/'media'/'members'/'about'
     *
     * group_id - Type: guid. Desc: id
     *
     * member_toggle - Type: bool. Desc: bool
     *
     * origin - Type: string. Desc: save_button
     *
     * show_media - Type: bool. Desc: bool
     *
     * show_members - Type: bool. Desc: bool
     *
     * tabName - Type: string. Desc: 'details'/'tabs'/'permissions'
     *
     * type - Type: string. Desc: 'private'/'public'/'secret'
     *
     * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp
     *
     * withPhoto - Type: bool. Desc: t/f
     * @param {groupSettingsSaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupSettingsSave = function (params) {
        return this.bi.log(__assign({ evid: 10 }, params));
    };
    /**
    * @typedef {Object} clubPostOptionsFollowPostParams
    * @property {GUID} clubId - null
    * @property {string} container - null
    * @property {GUID} postId - null
    * @property {string} userClass - null
    * @property {string} value - null
    **/
    /**
     * Name: Club post -> options -> Follow Post. Evid: 223.
    
    
     * clubId - Type: guid.
     *
     * container - Type: string.
     *
     * postId - Type: guid.
     *
     * userClass - Type: string.
     *
     * value - Type: string.
     * @param {clubPostOptionsFollowPostParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clubPostOptionsFollowPost = function (params) {
        return this.bi.log(__assign({ evid: 223 }, params));
    };
    /**
    * @typedef {Object} groupsCreateGroupClickParams
    * @property {string} origin - plus_btn / empty_state_btn / settings_create_first_grp_btn / groups_templates_scr
    * @property {GUID} templateId - template id
    * @property {string} templateName - staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
    * @property {string} userEntry - bizmgr/site/editor/oneapp
    **/
    /**
     * Name: Groups-> Create Group Click. Evid: 763.
    
    
     * origin - Type: string. Desc: plus_btn / empty_state_btn / settings_create_first_grp_btn / groups_templates_scr
     *
     * templateId - Type: guid. Desc: template id
     *
     * templateName - Type: string. Desc: staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
     *
     * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
     * @param {groupsCreateGroupClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsCreateGroupClick = function (params) {
        return this.bi.log(__assign({ evid: 763 }, params));
    };
    /**
    * @typedef {Object} changeListLayoutParams
    * @property {string} layout - grid/list
    **/
    /**
     * Name: change list layout (deprecated). Evid: 18.
     * Event description: changed groups list layout.
    
     * layout - Type: string. Desc: grid/list
     * @param {changeListLayoutParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeListLayout = function (params) {
        return this.bi.log(__assign({ evid: 18 }, params));
    };
    /**
    * @typedef {Object} groupsSelectGroupFromListParams
    * @property {string} componentName - groups / groups_list_widget
    * @property {GUID} groupId - null
    * @property {string} origin - view_btn / group_title / group_image / group_block / groups_my_group_tab_view_btn
    * @property {string} pageName - from which page click was made
    * @property {string} userEntry - bizmgr/site/members_area/oneapp
    **/
    /**
     * Name: Groups -> Select group from list. Evid: 566.
    
    
     * componentName - Type: string. Desc: groups / groups_list_widget
     *
     * groupId - Type: guid.
     *
     * origin - Type: string. Desc: view_btn / group_title / group_image / group_block / groups_my_group_tab_view_btn
     *
     * pageName - Type: string. Desc: from which page click was made
     *
     * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp
     * @param {groupsSelectGroupFromListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsSelectGroupFromList = function (params) {
        return this.bi.log(__assign({ evid: 566 }, params));
    };
    /**
    * @typedef {Object} sendEmailDigestToggleParams
    * @property {string} digestToggle - enable/disable
    * @property {string} origin - groups_settings_screen
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Send Email Digest Toggle. Evid: 43.
     * Event description: Send Email Digest Toggle.
    
     * digestToggle - Type: string. Desc: enable/disable
     *
     * origin - Type: string. Desc: groups_settings_screen
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {sendEmailDigestToggleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.sendEmailDigestToggle = function (params) {
        return this.bi.log(__assign({ evid: 43 }, params));
    };
    /**
    * @typedef {Object} memberTabAdminActionDoneParams
    * @property {string} action - remove_admin/remove_member/set_admin
    * @property {GUID} group_id - group
    * @property {string} origin - origin: dialog_screen_btn_clk
    * @property {GUID} site_member_id - member id
    * @property {string} userEntry - site / bizmngr
    **/
    /**
     * Name: Group - > member tab admin action done. Evid: 15.
     * Event description: completed admin action.
    
     * action - Type: string. Desc: remove_admin/remove_member/set_admin
     *
     * group_id - Type: guid. Desc: group
     *
     * origin - Type: string. Desc: origin: dialog_screen_btn_clk
     *
     * site_member_id - Type: guid. Desc: member id
     *
     * userEntry - Type: string. Desc: site / bizmngr
     * @param {memberTabAdminActionDoneParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.memberTabAdminActionDone = function (params) {
        return this.bi.log(__assign({ evid: 15 }, params));
    };
    /**
    * @typedef {Object} clubPostOptionsClickEditParams
    * @property {GUID} club_id - null
    * @property {GUID} clubId - null
    * @property {string} container - null
    * @property {string} post_id - null
    * @property {string} postId - null
    * @property {GUID} saleItemId - null
    * @property {string} type - null
    * @property {string} userClass - null
    **/
    /**
     * Name: Club post -> options -> click edit. Evid: 86.
    
    
     * club_id - Type: guid.
     *
     * clubId - Type: guid.
     *
     * container - Type: string.
     *
     * post_id - Type: string.
     *
     * postId - Type: string.
     *
     * saleItemId - Type: guid.
     *
     * type - Type: string.
     *
     * userClass - Type: string.
     * @param {clubPostOptionsClickEditParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clubPostOptionsClickEdit = function (params) {
        return this.bi.log(__assign({ evid: 86 }, params));
    };
    /**
    * @typedef {Object} groupsAboutEditClickedParams
    * @property {GUID} groupId - null
    * @property {string} origin - edit_descr_link
    * @property {string} userEntry - site / bizmngr
    **/
    /**
     * Name: Groups -> About -> Edit clicked. Evid: 559.
    
    
     * groupId - Type: guid.
     *
     * origin - Type: string. Desc: edit_descr_link
     *
     * userEntry - Type: string. Desc: site / bizmngr
     * @param {groupsAboutEditClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsAboutEditClicked = function (params) {
        return this.bi.log(__assign({ evid: 559 }, params));
    };
    /**
    * @typedef {Object} boGroupsSettingsOpenParams
    * @property {string} origin - groups_templates_scr
    * @property {GUID} templateId - template id (if you have it)
    * @property {string} templateName - staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
    * @property {string} userEntry - bizmgr/site/editor/oneapp
    **/
    /**
     * Name: Groups -> Click on Template Picture (Web). Evid: 23.
     * Event description: When user clicks on one of Template Pictures on Template Screen.
    
     * origin - Type: string. Desc: groups_templates_scr
     *
     * templateId - Type: guid. Desc: template id (if you have it)
     *
     * templateName - Type: string. Desc: staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
     *
     * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
     * @param {boGroupsSettingsOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.boGroupsSettingsOpen = function (params) {
        return this.bi.log(__assign({ evid: 23 }, params));
    };
    /**
    * @typedef {Object} groupsReplyToCommentClickParams
    * @property {GUID} groupId - group_id
    * @property {string} origin - feed_list/post
    * @property {string} userEntry - site/preview/oneapp
    **/
    /**
     * Name: Groups - Reply to Comment Click. Evid: 40.
     * Event description: User clicked on Reply to comment in Feed.
    
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: feed_list/post
     *
     * userEntry - Type: string. Desc: site/preview/oneapp
     * @param {groupsReplyToCommentClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsReplyToCommentClick = function (params) {
        return this.bi.log(__assign({ evid: 40 }, params));
    };
    /**
    * @typedef {Object} leaveGroupClickParams
    * @property {GUID} group_id - group
    * @property {string} origin - leave_dialog_modal
    * @property {string} userEntry - site
    **/
    /**
     * Name: Group page -> leave group click (dialog scr). Evid: 6.
     * Event description: user left group.
    
     * group_id - Type: guid. Desc: group
     *
     * origin - Type: string. Desc: leave_dialog_modal
     *
     * userEntry - Type: string. Desc: site
     * @param {leaveGroupClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.leaveGroupClick = function (params) {
        return this.bi.log(__assign({ evid: 6 }, params));
    };
    /**
    * @typedef {Object} memberActionParams
    * @property {string} action -
    * @property {GUID} group_id - group_id
    * @property {string} origin - about_tab_msg_clk /
    * @property {GUID} site_member_id - member id
    * @property {string} userEntry - site
    **/
    /**
     * Name: Group -> member message action. Evid: 13.
     * Event description: member message action.
    
     * action - Type: string.
     *
     * group_id - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: about_tab_msg_clk /
     *
     * site_member_id - Type: guid. Desc: member id
     *
     * userEntry - Type: string. Desc: site
     * @param {memberActionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.memberAction = function (params) {
        return this.bi.log(__assign({ evid: 13 }, params));
    };
    /**
    * @typedef {Object} groupsNewAboutSeeAllMembersParams
    * @property {GUID} group_id - null
    * @property {GUID} instance_id - null
    * @property {GUID} msid - null
    * @property {string} role - null
    * @property {string} roles - null
    * @property {GUID} uuid - null
    **/
    /**
     * Name: Groups-> New about- see all members. Evid: 721.
    
    
     * group_id - Type: guid.
     *
     * instance_id - Type: guid.
     *
     * msid - Type: guid.
     *
     * role - Type: string.
     *
     * roles - Type: string.
     *
     * uuid - Type: guid.
     * @param {groupsNewAboutSeeAllMembersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsNewAboutSeeAllMembers = function (params) {
        return this.bi.log(__assign({ evid: 721 }, params));
    };
    /**
    * @typedef {Object} groupEditCoverImageActionClickParams
    * @property {string} action - take_photo/ choose_from_device
    * @property {GUID} groupId - group_id
    * @property {GUID} msid - msid
    * @property {string} origin - img_action_modal
    * @property {string} userEntry - bizmngr / site / oneapp
    **/
    /**
     * Name: Group - Edit - Cover Image Action Click. Evid: 33.
     * Event description: Group - Edit - Cover Image Action Click.
    
     * action - Type: string. Desc: take_photo/ choose_from_device
     *
     * groupId - Type: guid. Desc: group_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: img_action_modal
     *
     * userEntry - Type: string. Desc: bizmngr / site / oneapp
     * @param {groupEditCoverImageActionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupEditCoverImageActionClick = function (params) {
        return this.bi.log(__assign({ evid: 33 }, params));
    };
    /**
    * @typedef {Object} groupsChoseGroupsSortByParams
    * @property {string} origin - popup_menu
    * @property {string} sort_by - null
    * @property {string} userEntry - site / bizmngr
    **/
    /**
     * Name: Groups: chose groups sort by. Evid: 823.
    
    
     * origin - Type: string. Desc: popup_menu
     *
     * sort_by - Type: string.
     *
     * userEntry - Type: string. Desc: site / bizmngr
     * @param {groupsChoseGroupsSortByParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsChoseGroupsSortBy = function (params) {
        return this.bi.log(__assign({ evid: 823 }, params));
    };
    /**
    * @typedef {Object} groupEditSaveParams
    * @property {GUID} groupId - group_id
    * @property {GUID} msid - msid
    * @property {string} origin - group_edit_scr
    * @property {string} userEntry - bizmngr / site / oneapp
    **/
    /**
     * Name: Group -> Edit -> Save. Evid: 30.
     * Event description: Group -> Edit -> Save.
    
     * groupId - Type: guid. Desc: group_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: group_edit_scr
     *
     * userEntry - Type: string. Desc: bizmngr / site / oneapp
     * @param {groupEditSaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupEditSave = function (params) {
        return this.bi.log(__assign({ evid: 30 }, params));
    };
    /**
    * @typedef {Object} groupsSendLinkToGetGroupsOnWebClickedParams
    * @property {string} action - learn_more/send_link/close
    * @property {string} origin - groups_list_scr / get_web_link_scr
    * @property {string} userEntry - oneapp
    **/
    /**
     * Name: Groups - Send Link to Get Groups on Web Clicked. Evid: 53.
     * Event description: Groups - Send Link to Get Groups on Web Clicked.
    
     * action - Type: string. Desc: learn_more/send_link/close
     *
     * origin - Type: string. Desc: groups_list_scr / get_web_link_scr
     *
     * userEntry - Type: string. Desc: oneapp
     * @param {groupsSendLinkToGetGroupsOnWebClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsSendLinkToGetGroupsOnWebClicked = function (params) {
        return this.bi.log(__assign({ evid: 53 }, params));
    };
    /**
    * @typedef {Object} groupsSearchForGroupParams
    * @property {string} group_name - null
    * @property {string} origin - top_panel_editbox
    * @property {string} userEntry - site / bizmngr
    **/
    /**
     * Name: Groups: search for group. Evid: 824.
    
    
     * group_name - Type: string.
     *
     * origin - Type: string. Desc: top_panel_editbox
     *
     * userEntry - Type: string. Desc: site / bizmngr
     * @param {groupsSearchForGroupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsSearchForGroup = function (params) {
        return this.bi.log(__assign({ evid: 824 }, params));
    };
    /**
    * @typedef {Object} groupEditMemberPermissionsToAddMembersIntentParams
    * @property {GUID} groupId - group_id
    * @property {string} origin - moderation_tab_plus_btn
    * @property {string} userEntry - bizmngr / site / oneapp
    **/
    /**
     * Name: Group -> Edit Member Permissions To Add members (Intent). Evid: 51.
     * Event description: Group -> Edit Member Permissions To Add members (Intent).
    
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: moderation_tab_plus_btn
     *
     * userEntry - Type: string. Desc: bizmngr / site / oneapp
     * @param {groupEditMemberPermissionsToAddMembersIntentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupEditMemberPermissionsToAddMembersIntent = function (params) {
        return this.bi.log(__assign({ evid: 51 }, params));
    };
    /**
    * @typedef {Object} groupViewPrivateMembersListParams
    * @property {GUID} groupId - group_id
    * @property {string} origin - memebrs_list_scr
    * @property {string} userEntry - oneapp/bizmngr/site
    **/
    /**
     * Name: Group -> View Private Members List. Evid: 57.
     * Event description: Group -> View Private Members List.
    
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: memebrs_list_scr
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr/site
     * @param {groupViewPrivateMembersListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupViewPrivateMembersList = function (params) {
        return this.bi.log(__assign({ evid: 57 }, params));
    };
    /**
    * @typedef {Object} groupsMemberClickOnThreeDotsParams
    * @property {GUID} groupId - null
    * @property {GUID} memberId - null
    * @property {string} memberUuid - null
    **/
    /**
     * Name: Groups -> member -> click on three dots. Evid: 574.
    
    
     * groupId - Type: guid.
     *
     * memberId - Type: guid.
     *
     * memberUuid - Type: string.
     * @param {groupsMemberClickOnThreeDotsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsMemberClickOnThreeDots = function (params) {
        return this.bi.log(__assign({ evid: 574 }, params));
    };
    /**
    * @typedef {Object} shareGroupClickParams
    * @property {GUID} group_id - group_id
    * @property {string} origin - share_dialog_modal
    * @property {string} type - 'facebook'/'twitter'/etc
    * @property {string} userEntry - site
    **/
    /**
     * Name: Group page -> share group click (dialog scr). Evid: 5.
     * Event description: clicked on share group.
    
     * group_id - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: share_dialog_modal
     *
     * type - Type: string. Desc: 'facebook'/'twitter'/etc
     *
     * userEntry - Type: string. Desc: site
     * @param {shareGroupClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.shareGroupClick = function (params) {
        return this.bi.log(__assign({ evid: 5 }, params));
    };
    /**
    * @typedef {Object} groupMembershipQuestionsMembershipQuestionsScreenLoadForMemberParams
    * @property {GUID} groupId - group_id
    * @property {string} origin - member_questions_screen
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Group ->  Membership Questions - Membership Questions Screen Load for Member. Evid: 48.
     * Event description: Group ->  Membership Questions - Membership Questions Screen Load for Member.
    
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: member_questions_screen
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupMembershipQuestionsMembershipQuestionsScreenLoadForMemberParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupMembershipQuestionsMembershipQuestionsScreenLoadForMember = function (params) {
        return this.bi.log(__assign({ evid: 48 }, params));
    };
    /**
    * @typedef {Object} groupFeedViewParams
    * @property {GUID} clubId - null
    * @property {string} container - null
    * @property {GUID} group_id - null
    * @property {boolean} has_only_auto_post - null
    * @property {string} origin - discussion_tab
    * @property {string} userEntry - site
    * @property {string} roles - null
    **/
    /**
     * Name: Group Feed View. Evid: 821.
    
    
     * clubId - Type: guid.
     *
     * container - Type: string.
     *
     * group_id - Type: guid.
     *
     * has_only_auto_post - Type: bool.
     *
     * origin - Type: string. Desc: discussion_tab
     *
     * userEntry - Type: string. Desc: site
     *
     * roles - Type: string.
     * @param {groupFeedViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupFeedView = function (params) {
        return this.bi.log(__assign({ evid: 821 }, params));
    };
    /**
    * @typedef {Object} showMemberJoinUpdateToggleParams
    * @property {string} origin - manage_group_updates_scr
    * @property {boolean} toggle - true/false
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Show Member Join Update Toggle. Evid: 41.
     * Event description: Show Member Join Update Toggle.
    
     * origin - Type: string. Desc: manage_group_updates_scr
     *
     * toggle - Type: bool. Desc: true/false
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {showMemberJoinUpdateToggleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.showMemberJoinUpdateToggle = function (params) {
        return this.bi.log(__assign({ evid: 41 }, params));
    };
    /**
    * @typedef {Object} followMemberParams
    * @property {string} action - follow/unfollow
    * @property {GUID} group_id - group
    * @property {string} origin - discussion_tab
    * @property {GUID} site_member_id - site member
    * @property {string} userEntry - site
    **/
    /**
     * Name: Group -> follow member. Evid: 12.
     * Event description: follow group member.
    
     * action - Type: string. Desc: follow/unfollow
     *
     * group_id - Type: guid. Desc: group
     *
     * origin - Type: string. Desc: discussion_tab
     *
     * site_member_id - Type: guid. Desc: site member
     *
     * userEntry - Type: string. Desc: site
     * @param {followMemberParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.followMember = function (params) {
        return this.bi.log(__assign({ evid: 12 }, params));
    };
    /**
    * @typedef {Object} groupsMemberRequestApproveDeclineParams
    * @property {GUID} groupId - null
    * @property {boolean} isAll - null
    * @property {GUID} memberId - null
    * @property {string} memberUuid - member ID
    * @property {string} origin - user_lvl_btn
    * @property {string} type - null
    * @property {string} userEntry - bizmgr/site/members_area/oneapp
    **/
    /**
     * Name: Groups -> member request -> approve / decline. Evid: 576.
    
    
     * groupId - Type: guid.
     *
     * isAll - Type: bool.
     *
     * memberId - Type: guid.
     *
     * memberUuid - Type: string. Desc: member ID
     *
     * origin - Type: string. Desc: user_lvl_btn
     *
     * type - Type: string.
     *
     * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp
     * @param {groupsMemberRequestApproveDeclineParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsMemberRequestApproveDecline = function (params) {
        return this.bi.log(__assign({ evid: 576 }, params));
    };
    /**
    * @typedef {Object} groupGroupRulesCreateRuleParams
    * @property {string} fromRuleTemplate - template characteristic if from template, null if own rule (not from template)
    * @property {GUID} groupId - group_id
    * @property {string} origin - rule_description_scr
    * @property {string} ruleDescription - rule description/ JSON
    * @property {number} ruleDescLength - count of characters in the description
    * @property {string} ruleTitle - rule title / JSON
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Group ->  Group Rules - Create Rule. Evid: 29.
     * Event description: Group ->  Group Rules - Create Rule.
    
     * fromRuleTemplate - Type: string. Desc: template characteristic if from template, null if own rule (not from template)
     *
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: rule_description_scr
     *
     * ruleDescription - Type: string. Desc: rule description/ JSON
     *
     * ruleDescLength - Type: numeric. Desc: count of characters in the description
     *
     * ruleTitle - Type: string. Desc: rule title / JSON
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupGroupRulesCreateRuleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupGroupRulesCreateRule = function (params) {
        return this.bi.log(__assign({ evid: 29 }, params));
    };
    /**
    * @typedef {Object} groupMembershipQuestionsCreateQuestionParams
    * @property {GUID} groupId - group_id
    * @property {boolean} isRequired - true/false
    * @property {string} origin - add_question_scr
    * @property {string} questionId - question ID
    * @property {number} questionIndex - q index
    * @property {number} questionLength - count of characters in the question
    * @property {string} questionText - question text/ JSON
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Group ->  Membership Questions - Create Question. Evid: 46.
    
    
     * groupId - Type: guid. Desc: group_id
     *
     * isRequired - Type: bool. Desc: true/false
     *
     * origin - Type: string. Desc: add_question_scr
     *
     * questionId - Type: string. Desc: question ID
     *
     * questionIndex - Type: numeric. Desc: q index
     *
     * questionLength - Type: numeric. Desc: count of characters in the question
     *
     * questionText - Type: string. Desc: question text/ JSON
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupMembershipQuestionsCreateQuestionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupMembershipQuestionsCreateQuestion = function (params) {
        return this.bi.log(__assign({ evid: 46 }, params));
    };
    /**
    * @typedef {Object} groupMembershipQuestionsMemberSubmitCloseAnswersParams
    * @property {string} action - submit/close
    * @property {number} countQuestions - (on submit) count of questions submitted
    * @property {GUID} groupId - group_id
    * @property {string} origin - member_questions_screen
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Group ->  Membership Questions - Member Submit/Close Answers. Evid: 49.
     * Event description: Group ->  Membership Questions - Member Submit/Close Answers.
    
     * action - Type: string. Desc: submit/close
     *
     * countQuestions - Type: numeric. Desc: (on submit) count of questions submitted
     *
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: member_questions_screen
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupMembershipQuestionsMemberSubmitCloseAnswersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupMembershipQuestionsMemberSubmitCloseAnswers = function (params) {
        return this.bi.log(__assign({ evid: 49 }, params));
    };
    /**
    * @typedef {Object} groupsPermisionForUouToCreateAGroupParams
    * @property {string} origin - save_btn
    * @property {string} permissions - members/owner_only/members_with_approval
    * @property {boolean} toggle - null
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Groups -> permision for UoU to create a group. Evid: 604.
    
    
     * origin - Type: string. Desc: save_btn
     *
     * permissions - Type: string. Desc: members/owner_only/members_with_approval
     *
     * toggle - Type: bool.
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupsPermisionForUouToCreateAGroupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsPermisionForUouToCreateAGroup = function (params) {
        return this.bi.log(__assign({ evid: 604 }, params));
    };
    /**
    * @typedef {Object} groupsUserPressedReadMoreParams
    * @property {GUID} group_id - null
    * @property {GUID} logged_session_uuid - null
    * @property {string} userClass - null
    * @property {string} roles - null
    * @property {GUID} uuid - null
    **/
    /**
     * Name: Groups -> User Pressed Read More. Evid: 698.
    
    
     * group_id - Type: guid.
     *
     * logged_session_uuid - Type: guid.
     *
     * userClass - Type: string.
     *
     * roles - Type: string.
     *
     * uuid - Type: guid.
     * @param {groupsUserPressedReadMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsUserPressedReadMore = function (params) {
        return this.bi.log(__assign({ evid: 698 }, params));
    };
    /**
    * @typedef {Object} groupsWelcomeToGroupsScreenLoadParams
    * @property {string} userEntry - oneapp
    **/
    /**
     * Name: Groups - Welcome to Groups Screen Load. Evid: 55.
    
    
     * userEntry - Type: string. Desc: oneapp
     * @param {groupsWelcomeToGroupsScreenLoadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsWelcomeToGroupsScreenLoad = function (params) {
        return this.bi.log(__assign({ evid: 55 }, params));
    };
    /**
    * @typedef {Object} changeListDisplayParams
    * @property {string} info - member_count/group_list_title/etc
    * @property {boolean} is_shown - bool
    **/
    /**
     * Name: change list display (deprecated). Evid: 19.
     * Event description: changed list display.
    
     * info - Type: string. Desc: member_count/group_list_title/etc
     *
     * is_shown - Type: bool. Desc: bool
     * @param {changeListDisplayParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeListDisplay = function (params) {
        return this.bi.log(__assign({ evid: 19 }, params));
    };
    /**
    * @typedef {Object} addMemberSkipClickedParams
    * @property {GUID} group_id - value
    * @property {string} origin - "members_list_scr"/"inv_members_scr"
    * @property {string} userEntry - oneapp
    **/
    /**
     * Name: Add Member Skip Clicked. Evid: 27.
     * Event description: Add Member Skip Clicked.
    
     * group_id - Type: guid. Desc: value
     *
     * origin - Type: string. Desc: "members_list_scr"/"inv_members_scr"
     *
     * userEntry - Type: string. Desc: oneapp
     * @param {addMemberSkipClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.addMemberSkipClicked = function (params) {
        return this.bi.log(__assign({ evid: 27 }, params));
    };
    /**
    * @typedef {Object} groupEditCloseParams
    * @property {GUID} groupId - group_id
    * @property {GUID} msid - msid
    * @property {string} origin - group_edit_scr
    * @property {string} userEntry - bizmngr / site / oneapp
    **/
    /**
     * Name: Group -> Edit -> Close. Evid: 31.
     * Event description: Group -> Edit -> Save.
    
     * groupId - Type: guid. Desc: group_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: group_edit_scr
     *
     * userEntry - Type: string. Desc: bizmngr / site / oneapp
     * @param {groupEditCloseParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupEditClose = function (params) {
        return this.bi.log(__assign({ evid: 31 }, params));
    };
    /**
    * @typedef {Object} groupGroupRulesRuleActionsParams
    * @property {string} action - open/edit/delete
    * @property {GUID} groupId - group_id
    * @property {string} origin - 1)details_tab_rule_area, 2)details_tab_edit_btn, 3)details_tab_delete_icon
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Group ->  Group Rules - Rule Actions. Evid: 36.
     * Event description: Group ->  Group Rules - Rule Actions.
    
     * action - Type: string. Desc: open/edit/delete
     *
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: 1)details_tab_rule_area, 2)details_tab_edit_btn, 3)details_tab_delete_icon
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupGroupRulesRuleActionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupGroupRulesRuleActions = function (params) {
        return this.bi.log(__assign({ evid: 36 }, params));
    };
    /**
    * @typedef {Object} groupMembershipQuestionsAddQuestionClickIntentParams
    * @property {GUID} groupId - group_id
    * @property {string} origin - create_memb_question_scr_cta, memb_qs_scr_plus_btn
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Group ->  Membership Questions - Add Question Click (Intent). Evid: 45.
     * Event description: Group ->  Membership Questions - Add Question Click (Intent).
    
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: create_memb_question_scr_cta, memb_qs_scr_plus_btn
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupMembershipQuestionsAddQuestionClickIntentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupMembershipQuestionsAddQuestionClickIntent = function (params) {
        return this.bi.log(__assign({ evid: 45 }, params));
    };
    /**
    * @typedef {Object} groupsPageViewParams
    * @property {string} origin - explore_groups_button/link/etc...
    * @property {string} userEntry - bizmgr/site/members_area/oneapp
    **/
    /**
     * Name: Groups -> groups page view intention. Evid: 8.
     * Event description: user viewed groups list page intention (by button click etc).
    
     * origin - Type: string. Desc: explore_groups_button/link/etc...
     *
     * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp
     * @param {groupsPageViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsPageView = function (params) {
        return this.bi.log(__assign({ evid: 8 }, params));
    };
    /**
    * @typedef {Object} groupEditAddEditCoverImageParams
    * @property {string} action - add/edit
    * @property {GUID} groupId - group_id
    * @property {GUID} msid - msid
    * @property {string} origin - group_edit_scr_add_img_btn/group_edit_scr_edit_btn
    * @property {string} userEntry - bizmngr / site / oneapp
    **/
    /**
     * Name: Group - Edit - Add / Edit Cover Image. Evid: 32.
     * Event description: Group - Edit - Add /Edit Cover Image.
    
     * action - Type: string. Desc: add/edit
     *
     * groupId - Type: guid. Desc: group_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: group_edit_scr_add_img_btn/group_edit_scr_edit_btn
     *
     * userEntry - Type: string. Desc: bizmngr / site / oneapp
     * @param {groupEditAddEditCoverImageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupEditAddEditCoverImage = function (params) {
        return this.bi.log(__assign({ evid: 32 }, params));
    };
    /**
    * @typedef {Object} groupsAddMemberClickedParams
    * @property {GUID} groupId - null
    * @property {string} origin - null
    * @property {string} pageName - name of initiating page on the site
    * @property {string} userEntry - oneapp/site/bizmngr
    **/
    /**
     * Name: Groups -> add member clicked. Evid: 569.
    
    
     * groupId - Type: guid.
     *
     * origin - Type: string.
     *
     * pageName - Type: string. Desc: name of initiating page on the site
     *
     * userEntry - Type: string. Desc: oneapp/site/bizmngr
     * @param {groupsAddMemberClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsAddMemberClicked = function (params) {
        return this.bi.log(__assign({ evid: 569 }, params));
    };
    /**
    * @typedef {Object} clubDeleteClubParams
    * @property {GUID} club_id - null
    * @property {GUID} clubId - null
    * @property {string} userClass - null
    **/
    /**
     * Name: Club -> delete club. Evid: 167.
    
    
     * club_id - Type: guid.
     *
     * clubId - Type: guid.
     *
     * userClass - Type: string.
     * @param {clubDeleteClubParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clubDeleteClub = function (params) {
        return this.bi.log(__assign({ evid: 167 }, params));
    };
    /**
    * @typedef {Object} groupsAppSettingsSaveParams
    * @property {string} category - layout/settings/display....
    * @property {boolean} member_toggle -
    * @property {string} origin -
    * @property {string} subcategory - image_ratio/title_align...etc
    * @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
    * @property {string} value - value of subcategory's change
    **/
    /**
     * Name: Groups -> app settings save. Evid: 20.
     * Event description: groups app settings change and save.
    
     * category - Type: string. Desc: layout/settings/display....
     *
     * member_toggle - Type: bool.
     *
     * origin - Type: string.
     *
     * subcategory - Type: string. Desc: image_ratio/title_align...etc
     *
     * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
     *
     * value - Type: string. Desc: value of subcategory's change
     * @param {groupsAppSettingsSaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsAppSettingsSave = function (params) {
        return this.bi.log(__assign({ evid: 20 }, params));
    };
    /**
    * @typedef {Object} groupMembershipQuestionsOwnerViewAnswersParams
    * @property {GUID} groupId - group_id
    * @property {string} memberUuid - member ID
    * @property {string} origin - member_questions_screen
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Group ->  Membership Questions - Owner View Answers. Evid: 50.
     * Event description: Group ->  Membership Questions - Owner View Answers.
    
     * groupId - Type: guid. Desc: group_id
     *
     * memberUuid - Type: string. Desc: member ID
     *
     * origin - Type: string. Desc: member_questions_screen
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupMembershipQuestionsOwnerViewAnswersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupMembershipQuestionsOwnerViewAnswers = function (params) {
        return this.bi.log(__assign({ evid: 50 }, params));
    };
    /**
    * @typedef {Object} groupCreatePostClickParams
    * @property {GUID} group_id - group id
    * @property {GUID} groupId - group_id
    * @property {string} origin - top_rce_area/media_tab_btn
    * @property {string} userEntry - site/preview
    **/
    /**
     * Name: Group -> Create Post Click. Evid: 38.
     * Event description: User clicked to create post.
    
     * group_id - Type: guid. Desc: group id
     *
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: top_rce_area/media_tab_btn
     *
     * userEntry - Type: string. Desc: site/preview
     * @param {groupCreatePostClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupCreatePostClick = function (params) {
        return this.bi.log(__assign({ evid: 38 }, params));
    };
    /**
    * @typedef {Object} moderationSettingsClickedParams
    * @property {string} groupId - group ID
    * @property {string} origin - groups_settings_screen
    * @property {string} settings - edit_permissions, 	membership_questions, 	manage_group_rules, 	manage_group_updates,
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Moderation Settings Clicked. Evid: 44.
     * Event description: User clicks one of Moderation Settings buttons.
    
     * groupId - Type: string. Desc: group ID
     *
     * origin - Type: string. Desc: groups_settings_screen
     *
     * settings - Type: string. Desc: edit_permissions, 	membership_questions, 	manage_group_rules, 	manage_group_updates,
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {moderationSettingsClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.moderationSettingsClicked = function (params) {
        return this.bi.log(__assign({ evid: 44 }, params));
    };
    /*event 1 on project 'com.wixpress.groups has no function name set, please set one in BI Catalog.*/
    /**
    * @typedef {Object} groupNotificationsSettingsSaveParams
    * @property {boolean} comments - bool
    * @property {boolean} emailToggle - bool
    * @property {GUID} groupId - id
    * @property {boolean} groupUpdates - bool
    * @property {boolean} membersJoined - bool
    * @property {boolean} mobileAppToggle - bool
    * @property {boolean} newMembers - bool
    * @property {boolean} posts - bool
    * @property {boolean} reactions - bool
    * @property {string} tabName - website/email/mobile_app
    * @property {string} origin - save_btn
    * @property {string} userEntry - site
    * @property {boolean} websiteToggle - bool
    **/
    /**
     * Name: Group - Notifications Settings Save. Evid: 54.
     * Event description: Saves new Notifications settings.
    
     * comments - Type: bool. Desc: bool
     *
     * emailToggle - Type: bool. Desc: bool
     *
     * groupId - Type: guid. Desc: id
     *
     * groupUpdates - Type: bool. Desc: bool
     *
     * membersJoined - Type: bool. Desc: bool
     *
     * mobileAppToggle - Type: bool. Desc: bool
     *
     * newMembers - Type: bool. Desc: bool
     *
     * posts - Type: bool. Desc: bool
     *
     * reactions - Type: bool. Desc: bool
     *
     * tabName - Type: string. Desc: website/email/mobile_app
     *
     * origin - Type: string. Desc: save_btn
     *
     * userEntry - Type: string. Desc: site
     *
     * websiteToggle - Type: bool. Desc: bool
     * @param {groupNotificationsSettingsSaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupNotificationsSettingsSave = function (params) {
        return this.bi.log(__assign({ evid: 54 }, params));
    };
    /**
    * @typedef {Object} groupInvitesClickToInviteMembersFromTheOptionListParams
    * @property {string} method - method
    * @property {GUID} msid - msid
    **/
    /**
     * Name: Group -> invites -> click to invite members from the option list. Evid: 409.
     * Event description: When user clicks to invite members from different types of methods: in app invited (other groups, sms, email, etc..) ALSO INCLUDES WIX PROMOTE WHEN SHARING DP INVITE FROM THEIR FLOW.
    
     * method - Type: string. Desc: method
     *
     * msid - Type: guid. Desc: msid
     * @param {groupInvitesClickToInviteMembersFromTheOptionListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupInvitesClickToInviteMembersFromTheOptionList = function (params) {
        return this.bi.log(__assign({ evid: 409 }, params));
    };
    /**
    * @typedef {Object} clubPostOptionsClickDeleteParams
    * @property {GUID} club_id - null
    * @property {GUID} clubId - null
    * @property {string} container - null
    * @property {GUID} post_id - null
    * @property {GUID} postId - null
    * @property {string} type - null
    * @property {string} userClass - null
    **/
    /**
     * Name: Club post -> options -> click delete. Evid: 85.
    
    
     * club_id - Type: guid.
     *
     * clubId - Type: guid.
     *
     * container - Type: string.
     *
     * post_id - Type: guid.
     *
     * postId - Type: guid.
     *
     * type - Type: string.
     *
     * userClass - Type: string.
     * @param {clubPostOptionsClickDeleteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clubPostOptionsClickDelete = function (params) {
        return this.bi.log(__assign({ evid: 85 }, params));
    };
    /**
    * @typedef {Object} clubPostViewPostFullScreenParams
    * @property {string} app_id - null
    * @property {GUID} club_id - null
    * @property {GUID} clubId - null
    * @property {string} container - null
    * @property {boolean} isPinned - null
    * @property {string} origin - groups_my_posts_tab / groups_my_groups_tab
    * @property {string} post_id - null
    * @property {string} postId - null
    * @property {string} type - null
    * @property {string} userClass - null
    * @property {string} userEntry - bizmngr / site
    **/
    /**
     * Name: Club post -> view post full screen. Evid: 87.
    
    
     * app_id - Type: string.
     *
     * club_id - Type: guid.
     *
     * clubId - Type: guid.
     *
     * container - Type: string.
     *
     * isPinned - Type: bool.
     *
     * origin - Type: string. Desc: groups_my_posts_tab / groups_my_groups_tab
     *
     * post_id - Type: string.
     *
     * postId - Type: string.
     *
     * type - Type: string.
     *
     * userClass - Type: string.
     *
     * userEntry - Type: string. Desc: bizmngr / site
     * @param {clubPostViewPostFullScreenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clubPostViewPostFullScreen = function (params) {
        return this.bi.log(__assign({ evid: 87 }, params));
    };
    /**
    * @typedef {Object} groupsTabClickedParams
    * @property {GUID} group_id - group_id
    * @property {string} name - tab name
    * @property {string} origin - tabs / see_all_members_link / pinned_window
    * @property {string} userEntry - site
    **/
    /**
     * Name: Groups -> Tab clicked. Evid: 558.
     * Event description: When a user clicks on a tab in the group view.
    
     * group_id - Type: guid. Desc: group_id
     *
     * name - Type: string. Desc: tab name
     *
     * origin - Type: string. Desc: tabs / see_all_members_link / pinned_window
     *
     * userEntry - Type: string. Desc: site
     * @param {groupsTabClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsTabClicked = function (params) {
        return this.bi.log(__assign({ evid: 558 }, params));
    };
    /**
    * @typedef {Object} groupsSharePostParams
    * @property {GUID} group_id - null
    * @property {string} origin - null
    * @property {string} post_id - null
    * @property {string} userClass - null
    **/
    /**
     * Name: Groups -> Share Post. Evid: 678.
    
    
     * group_id - Type: guid.
     *
     * origin - Type: string.
     *
     * post_id - Type: string.
     *
     * userClass - Type: string.
     * @param {groupsSharePostParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsSharePost = function (params) {
        return this.bi.log(__assign({ evid: 678 }, params));
    };
    /**
    * @typedef {Object} groupSettingsOpenParams
    * @property {GUID} group_id - group
    * @property {string} origin - on_group_settings_btn
    * @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
    **/
    /**
     * Name: Group -> settings open. Evid: 21.
     * Event description: group page settings open.
    
     * group_id - Type: guid. Desc: group
     *
     * origin - Type: string. Desc: on_group_settings_btn
     *
     * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
     * @param {groupSettingsOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupSettingsOpen = function (params) {
        return this.bi.log(__assign({ evid: 21 }, params));
    };
    /**
    * @typedef {Object} groupsActionClickedParams
    * @property {string} name - name of the action
    **/
    /**
     * Name: Groups -> Action clicked. Evid: 563.
    
    
     * name - Type: string. Desc: name of the action
     * @param {groupsActionClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsActionClicked = function (params) {
        return this.bi.log(__assign({ evid: 563 }, params));
    };
    /**
    * @typedef {Object} groupsSelectAllMembersClickedParams
    * @property {string} action - select/unselect
    * @property {number} count - count of selected Members
    * @property {GUID} groupId - Group ID
    * @property {string} membersType - private/public
    * @property {string} origin - 'members_list_scr'
    * @property {string} userEntry - oneapp/site/bizmngr
    **/
    /**
     * Name: Groups -> Select All Members Clicked. Evid: 570.
     * Event description: Groups -> Select All Members Clicked.
    
     * action - Type: string. Desc: select/unselect
     *
     * count - Type: numeric. Desc: count of selected Members
     *
     * groupId - Type: guid. Desc: Group ID
     *
     * membersType - Type: string. Desc: private/public
     *
     * origin - Type: string. Desc: 'members_list_scr'
     *
     * userEntry - Type: string. Desc: oneapp/site/bizmngr
     * @param {groupsSelectAllMembersClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsSelectAllMembersClicked = function (params) {
        return this.bi.log(__assign({ evid: 570 }, params));
    };
    /**
    * @typedef {Object} groupsTemplatesPageLoadParams
    * @property {string} origin - groups_templates_scr
    * @property {string} userEntry - bizmgr/site/editor/oneapp
    **/
    /**
     * Name: Groups - Templates Page Load. Evid: 35.
     * Event description: When user arrives at the Groups Templates page.
    
     * origin - Type: string. Desc: groups_templates_scr
     *
     * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
     * @param {groupsTemplatesPageLoadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsTemplatesPageLoad = function (params) {
        return this.bi.log(__assign({ evid: 35 }, params));
    };
    /**
    * @typedef {Object} boGroupDetailsClickParams
    * @property {GUID} group_id - group
    * @property {string} origin - three_dots_btn
    * @property {string} userEntry - bizmngr
    **/
    /**
     * Name: !!!Clarify!!!!  -> bo group details click. Evid: 24.
     * Event description: click on group from group list in BO.
    
     * group_id - Type: guid. Desc: group
     *
     * origin - Type: string. Desc: three_dots_btn
     *
     * userEntry - Type: string. Desc: bizmngr
     * @param {boGroupDetailsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.boGroupDetailsClick = function (params) {
        return this.bi.log(__assign({ evid: 24 }, params));
    };
    /**
    * @typedef {Object} groupsSwitchBetweenGroupTabsParams
    * @property {GUID} club_id - null
    * @property {GUID} group_id - null
    * @property {GUID} msid - null
    * @property {string} targetTab - null
    * @property {string} userClass - null
    **/
    /**
     * Name: Groups-> switch between group tabs. Evid: 727.
    
    
     * club_id - Type: guid.
     *
     * group_id - Type: guid.
     *
     * msid - Type: guid.
     *
     * targetTab - Type: string.
     *
     * userClass - Type: string.
     * @param {groupsSwitchBetweenGroupTabsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsSwitchBetweenGroupTabs = function (params) {
        return this.bi.log(__assign({ evid: 727 }, params));
    };
    /**
    * @typedef {Object} groupsAddMemberClickDoneParams
    * @property {number} count - number of members added
    * @property {GUID} groupId - null
    * @property {string} membersType - private/public
    * @property {string} origin - 'members_list_scr'
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Groups -> add member -> click done. Evid: 571.
    
    
     * count - Type: numeric. Desc: number of members added
     *
     * groupId - Type: guid.
     *
     * membersType - Type: string. Desc: private/public
     *
     * origin - Type: string. Desc: 'members_list_scr'
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupsAddMemberClickDoneParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsAddMemberClickDone = function (params) {
        return this.bi.log(__assign({ evid: 571 }, params));
    };
    /**
    * @typedef {Object} reportGroupClickParams
    * @property {GUID} group_id - group
    * @property {string} origin - report_dialog_modal
    * @property {string} type - 'offensive_content'/'spam'/etc
    * @property {string} userEntry - site
    **/
    /**
     * Name: Group page -> report group click. Evid: 7.
     * Event description: report group.
    
     * group_id - Type: guid. Desc: group
     *
     * origin - Type: string. Desc: report_dialog_modal
     *
     * type - Type: string. Desc: 'offensive_content'/'spam'/etc
     *
     * userEntry - Type: string. Desc: site
     * @param {reportGroupClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.reportGroupClick = function (params) {
        return this.bi.log(__assign({ evid: 7 }, params));
    };
    /**
    * @typedef {Object} groupsAboutEditSaveParams
    * @property {GUID} groupId - null
    * @property {number} length - null
    * @property {string} origin - modal_scrn_save_btn
    * @property {string} userEntry - site / bizmngr
    **/
    /**
     * Name: Groups -> About -> Edit -> Save. Evid: 560.
    
    
     * groupId - Type: guid.
     *
     * length - Type: numeric.
     *
     * origin - Type: string. Desc: modal_scrn_save_btn
     *
     * userEntry - Type: string. Desc: site / bizmngr
     * @param {groupsAboutEditSaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsAboutEditSave = function (params) {
        return this.bi.log(__assign({ evid: 560 }, params));
    };
    /**
    * @typedef {Object} inviteSentParams
    * @property {string} contact - e-mail address
    * @property {GUID} group_id - group id
    * @property {string} origin - dialog_scr_invite_btn
    * @property {GUID} site_member_id - site_member_id
    * @property {string} userEntry - bizmngr/site
    **/
    /**
     * Name: Invite Members -> invite send. Evid: 9.
     * Event description: send invite by mail.
    
     * contact - Type: string. Desc: e-mail address
     *
     * group_id - Type: guid. Desc: group id
     *
     * origin - Type: string. Desc: dialog_scr_invite_btn
     *
     * site_member_id - Type: guid. Desc: site_member_id
     *
     * userEntry - Type: string. Desc: bizmngr/site
     * @param {inviteSentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.inviteSent = function (params) {
        return this.bi.log(__assign({ evid: 9 }, params));
    };
    /**
    * @typedef {Object} inviteMembersClickParams
    * @property {GUID} group_id - group
    * @property {string} origin - top_pnl_invite_btn / invite_modal_scrn_invite_btn
    * @property {string} userEntry - bizmngr / site / etc...
    **/
    /**
     * Name: Group -> invite members click. Evid: 25.
     * Event description: clicked invite members.
    
     * group_id - Type: guid. Desc: group
     *
     * origin - Type: string. Desc: top_pnl_invite_btn / invite_modal_scrn_invite_btn
     *
     * userEntry - Type: string. Desc: bizmngr / site / etc...
     * @param {inviteMembersClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.inviteMembersClick = function (params) {
        return this.bi.log(__assign({ evid: 25 }, params));
    };
    /**
    * @typedef {Object} memberTabAdminActionClickParams
    * @property {string} action - remove_admin/remove_member/set_admin
    * @property {GUID} group_id - group_id
    * @property {string} origin - member_tab_member_option_clk
    * @property {GUID} site_member_id - member
    * @property {string} userEntry - site / bizmngr
    **/
    /**
     * Name: Group -> member tab admin action click. Evid: 14.
     * Event description: admin actions in member tab (3 dots).
    
     * action - Type: string. Desc: remove_admin/remove_member/set_admin
     *
     * group_id - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: member_tab_member_option_clk
     *
     * site_member_id - Type: guid. Desc: member
     *
     * userEntry - Type: string. Desc: site / bizmngr
     * @param {memberTabAdminActionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.memberTabAdminActionClick = function (params) {
        return this.bi.log(__assign({ evid: 14 }, params));
    };
    /**
    * @typedef {Object} groupSettingsSelectSettingsAreaFromListParams
    * @property {GUID} groupId - group ID
    * @property {string} name - Settings area name
    * @property {string} origin - manage_tab/ null for add_on settings
    **/
    /**
     * Name: Group -> Settings -> Select Settings area from list. Evid: 572.
    
    
     * groupId - Type: guid. Desc: group ID
     *
     * name - Type: string. Desc: Settings area name
     *
     * origin - Type: string. Desc: manage_tab/ null for add_on settings
     * @param {groupSettingsSelectSettingsAreaFromListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupSettingsSelectSettingsAreaFromList = function (params) {
        return this.bi.log(__assign({ evid: 572 }, params));
    };
    /**
    * @typedef {Object} groupListSettingsOpenParams
    * @property {string} origin - origin
    * @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
    **/
    /**
     * Name: Group -> list settings open. Evid: 16.
     * Event description: user opened group list settings.
    
     * origin - Type: string. Desc: origin
     *
     * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
     * @param {groupListSettingsOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupListSettingsOpen = function (params) {
        return this.bi.log(__assign({ evid: 16 }, params));
    };
    /**
    * @typedef {Object} groupsSelectCommentTemplateClickParams
    * @property {GUID} groupId - group_id
    * @property {string} origin - feed_list/post
    * @property {string} template - template name
    * @property {string} type - template type
    * @property {string} userEntry - site/preview/oneapp
    **/
    /**
     * Name: Groups - Select Comment Template Click. Evid: 39.
     * Event description: User clicked on comment template in Feed.
    
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: feed_list/post
     *
     * template - Type: string. Desc: template name
     *
     * type - Type: string. Desc: template type
     *
     * userEntry - Type: string. Desc: site/preview/oneapp
     * @param {groupsSelectCommentTemplateClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsSelectCommentTemplateClick = function (params) {
        return this.bi.log(__assign({ evid: 39 }, params));
    };
    /**
    * @typedef {Object} forsaleNewForsalePostCreatedParams
    * @property {GUID} clubId - null
    * @property {string} container - null
    * @property {string} currency - null
    * @property {string} origin - null
    * @property {GUID} postId - null
    * @property {number} price - null
    * @property {GUID} saleItemId - null
    * @property {string} userClass - null
    * @property {boolean} withPhoto - null
    **/
    /**
     * Name: Forsale -> new forsale post created. Evid: 483.
    
    
     * clubId - Type: guid.
     *
     * container - Type: string.
     *
     * currency - Type: string.
     *
     * origin - Type: string.
     *
     * postId - Type: guid.
     *
     * price - Type: numeric.
     *
     * saleItemId - Type: guid.
     *
     * userClass - Type: string.
     *
     * withPhoto - Type: bool.
     * @param {forsaleNewForsalePostCreatedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.forsaleNewForsalePostCreated = function (params) {
        return this.bi.log(__assign({ evid: 483 }, params));
    };
    /**
    * @typedef {Object} groupsChangedDefaultSortParams
    * @property {string} sort_by - null
    **/
    /**
     * Name: Groups: changed default sort. Evid: 822.
    
    
     * sort_by - Type: string.
     * @param {groupsChangedDefaultSortParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsChangedDefaultSort = function (params) {
        return this.bi.log(__assign({ evid: 822 }, params));
    };
    /**
    * @typedef {Object} showGroupDetailsUpdateToggleParams
    * @property {string} origin - null
    * @property {boolean} toggle - true/false
    * @property {string} userEntry - null
    **/
    /**
     * Name: Show Group Details Update Toggle. Evid: 42.
     * Event description: Show Group Details Update Toggle.
    
     * origin - Type: string.
     *
     * toggle - Type: bool. Desc: true/false
     *
     * userEntry - Type: string.
     * @param {showGroupDetailsUpdateToggleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.showGroupDetailsUpdateToggle = function (params) {
        return this.bi.log(__assign({ evid: 42 }, params));
    };
    /**
    * @typedef {Object} groupsMemberRequestToCreateAGroupApproveDeclineParams
    * @property {string} actionType - approve / decline
    * @property {GUID} groupId - value
    * @property {boolean} isAll - Decline or approve all true / false
    * @property {GUID} memberId - value
    * @property {string} memberUuid - member ID
    * @property {string} origin - user_lvl_btn
    * @property {string} userEntry - bizmgr/site/ null if oneapp
    **/
    /**
     * Name: Groups -> member request to create a group -> approve / decline. Evid: 26.
     * Event description: Groups -> member request to create a group -> approve / decline.
    
     * actionType - Type: string. Desc: approve / decline
     *
     * groupId - Type: guid. Desc: value
     *
     * isAll - Type: bool. Desc: Decline or approve all true / false
     *
     * memberId - Type: guid. Desc: value
     *
     * memberUuid - Type: string. Desc: member ID
     *
     * origin - Type: string. Desc: user_lvl_btn
     *
     * userEntry - Type: string. Desc: bizmgr/site/ null if oneapp
     * @param {groupsMemberRequestToCreateAGroupApproveDeclineParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsMemberRequestToCreateAGroupApproveDecline = function (params) {
        return this.bi.log(__assign({ evid: 26 }, params));
    };
    /**
    * @typedef {Object} postActionClickParams
    * @property {string} action - 'delete'/'edit'/'share'/'follow'/'pin'
    * @property {GUID} group_id - group id
    * @property {string} origin - three_dots_menu
    * @property {string} post_id - post_id
    * @property {string} userEntry - site
    **/
    /**
     * Name: Discussion tab -> post action click. Evid: 3.
     * Event description: user clicked post action from three dots.
    
     * action - Type: string. Desc: 'delete'/'edit'/'share'/'follow'/'pin'
     *
     * group_id - Type: guid. Desc: group id
     *
     * origin - Type: string. Desc: three_dots_menu
     *
     * post_id - Type: string. Desc: post_id
     *
     * userEntry - Type: string. Desc: site
     * @param {postActionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postActionClick = function (params) {
        return this.bi.log(__assign({ evid: 3 }, params));
    };
    /**
    * @typedef {Object} groupsRenameTabClickSaveParams
    * @property {GUID} groupId - null
    * @property {string} name - null
    **/
    /**
     * Name: Groups -> rename tab -> click save. Evid: 573.
    
    
     * groupId - Type: guid.
     *
     * name - Type: string.
     * @param {groupsRenameTabClickSaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsRenameTabClickSave = function (params) {
        return this.bi.log(__assign({ evid: 573 }, params));
    };
    /**
    * @typedef {Object} groupMembershipQuestionsMembershipQuestionsSavedParams
    * @property {number} countQuestions - null
    * @property {GUID} groupId - group_id
    * @property {string} origin - add_question_scr
    * @property {string} questionsArray - JSON with all questions and is_required attribute
    * @property {string} userEntry - null
    **/
    /**
     * Name: Group ->  Membership Questions - Membership Questions Saved. Evid: 52.
     * Event description: Group ->  Membership Questions - Membership Questions Saved.
    
     * countQuestions - Type: numeric.
     *
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: add_question_scr
     *
     * questionsArray - Type: string. Desc: JSON with all questions and is_required attribute
     *
     * userEntry - Type: string.
     * @param {groupMembershipQuestionsMembershipQuestionsSavedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupMembershipQuestionsMembershipQuestionsSaved = function (params) {
        return this.bi.log(__assign({ evid: 52 }, params));
    };
    /**
    * @typedef {Object} clubPostAddPhotoParams
    * @property {GUID} club_id - null
    * @property {GUID} clubId - null
    * @property {string} container - null
    * @property {string} origin - null
    * @property {GUID} postId - null
    * @property {string} userClass - null
    **/
    /**
     * Name: Club post -> add photo. Evid: 80.
    
    
     * club_id - Type: guid.
     *
     * clubId - Type: guid.
     *
     * container - Type: string.
     *
     * origin - Type: string.
     *
     * postId - Type: guid.
     *
     * userClass - Type: string.
     * @param {clubPostAddPhotoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clubPostAddPhoto = function (params) {
        return this.bi.log(__assign({ evid: 80 }, params));
    };
    /**
    * @typedef {Object} groupsCreateSaveParams
    * @property {number} countMembersAdded - null
    * @property {string} origin - null
    * @property {string} type - null
    * @property {boolean} withPhoto - null
    **/
    /**
     * Name: Groups -> Create -> Save. Evid: 557.
    
    
     * countMembersAdded - Type: numeric.
     *
     * origin - Type: string.
     *
     * type - Type: string.
     *
     * withPhoto - Type: bool.
     * @param {groupsCreateSaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsCreateSave = function (params) {
        return this.bi.log(__assign({ evid: 557 }, params));
    };
    /**
    * @typedef {Object} groupsFeedInviteMembersParams
    * @property {GUID} group_id - null
    * @property {string} origin - null
    * @property {string} userClass - null
    **/
    /**
     * Name: Groups Feed -> Invite Members. Evid: 679.
     * Event description: The event is triggered when a user presses the share button (either from the share button or the post header) in the groups feed..
    
     * group_id - Type: guid.
     *
     * origin - Type: string.
     *
     * userClass - Type: string.
     * @param {groupsFeedInviteMembersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsFeedInviteMembers = function (params) {
        return this.bi.log(__assign({ evid: 679 }, params));
    };
    /**
    * @typedef {Object} groupsManageTabsParams
    * @property {GUID} group_id - null
    * @property {GUID} msid - null
    * @property {string} name - null
    **/
    /**
     * Name: Groups-> Manage Tabs. Evid: 753.
    
    
     * group_id - Type: guid.
     *
     * msid - Type: guid.
     *
     * name - Type: string.
     * @param {groupsManageTabsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsManageTabs = function (params) {
        return this.bi.log(__assign({ evid: 753 }, params));
    };
    /**
    * @typedef {Object} groupsTemplatesCloseParams
    * @property {string} origin - groups_templates_scr
    * @property {string} userEntry - bizmgr/site/editor/oneapp
    **/
    /**
     * Name: Groups-> Templates - Close. Evid: 34.
     * Event description: When user closes the Templates page.
    
     * origin - Type: string. Desc: groups_templates_scr
     *
     * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
     * @param {groupsTemplatesCloseParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsTemplatesClose = function (params) {
        return this.bi.log(__assign({ evid: 34 }, params));
    };
    /**
    * @typedef {Object} changeGroupPageDisplayParams
    * @property {string} category - layout/display...
    * @property {GUID} group_id - group
    * @property {string} info - member_count/group_list_title/etc
    * @property {string} origin - on_fly
    * @property {string} subcategory - discussions/media....
    * @property {string} userEntry - editor
    * @property {string} value - value of the subcategory that changed
    **/
    /**
     * Name: Group -> page settings save. Evid: 22.
     * Event description: changed list display.
    
     * category - Type: string. Desc: layout/display...
     *
     * group_id - Type: guid. Desc: group
     *
     * info - Type: string. Desc: member_count/group_list_title/etc
     *
     * origin - Type: string. Desc: on_fly
     *
     * subcategory - Type: string. Desc: discussions/media....
     *
     * userEntry - Type: string. Desc: editor
     *
     * value - Type: string. Desc: value of the subcategory that changed
     * @param {changeGroupPageDisplayParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeGroupPageDisplay = function (params) {
        return this.bi.log(__assign({ evid: 22 }, params));
    };
    /**
    * @typedef {Object} groupGroupRulesCreateRuleClickIntentParams
    * @property {string} fromRuleTemplate - template name, number or other characteristics if from template, null if own rule (not from template)
    * @property {GUID} groupId - group_id
    * @property {string} origin - create_rule_scr
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Group ->  Group Rules - Create Rule Click (Intent). Evid: 28.
     * Event description: Group ->  Group Rules - Create Rule Click (Intent).
    
     * fromRuleTemplate - Type: string. Desc: template name, number or other characteristics if from template, null if own rule (not from template)
     *
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: create_rule_scr
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupGroupRulesCreateRuleClickIntentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupGroupRulesCreateRuleClickIntent = function (params) {
        return this.bi.log(__assign({ evid: 28 }, params));
    };
    /**
    * @typedef {Object} groupsWelcomeToGroupsScreenClickParams
    * @property {string} action - get_started/back
    * @property {string} userEntry - oneapp
    **/
    /**
     * Name: Groups - Welcome to Groups Screen Click. Evid: 56.
     * Event description: Groups - Welcome to Groups Screen Click.
    
     * action - Type: string. Desc: get_started/back
     *
     * userEntry - Type: string. Desc: oneapp
     * @param {groupsWelcomeToGroupsScreenClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsWelcomeToGroupsScreenClick = function (params) {
        return this.bi.log(__assign({ evid: 56 }, params));
    };
    /**
    * @typedef {Object} groupsEditClickedParams
    * @property {GUID} groupId - null
    * @property {string} origin - to_header_add_member_btn / group_member_icon_btn / hint_created_add_member_btn
    * @property {string} userEntry - bizmngr / site / oneapp
    **/
    /**
     * Name: Groups -> edit clicked. Evid: 568.
    
    
     * groupId - Type: guid.
     *
     * origin - Type: string. Desc: to_header_add_member_btn / group_member_icon_btn / hint_created_add_member_btn
     *
     * userEntry - Type: string. Desc: bizmngr / site / oneapp
     * @param {groupsEditClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsEditClicked = function (params) {
        return this.bi.log(__assign({ evid: 568 }, params));
    };
    /**
    * @typedef {Object} groupsBoLoadedParams
    * @property {string} origin - pnl_manage_groups_btn / settings_pnl_manage_groups_btn / on_group_manage_groups_btn / bo_groups_btn
    * @property {string} userEntry - bizmgr/site/members_area/oneapp/editor
    **/
    /**
     * Name: Groups -> bo loaded. Evid: 17.
     * Event description: backoffice loaded.
    
     * origin - Type: string. Desc: pnl_manage_groups_btn / settings_pnl_manage_groups_btn / on_group_manage_groups_btn / bo_groups_btn
     *
     * userEntry - Type: string. Desc: bizmgr/site/members_area/oneapp/editor
     * @param {groupsBoLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsBoLoaded = function (params) {
        return this.bi.log(__assign({ evid: 17 }, params));
    };
    /**
    * @typedef {Object} groupMembershipQuestionsQuestionActionsParams
    * @property {string} action - open/edit/remove/delete/cancel
    * @property {GUID} groupId - group_id
    * @property {string} origin - edit_qs_scr_question_area, edit_qs_scr_three_dots, edit_question_modal, delete_question_modal
    * @property {string} questionId - question ID
    * @property {number} questionIndex - q index
    * @property {string} userEntry - oneapp/bizmngr
    **/
    /**
     * Name: Group ->  Membership Questions - Question Actions. Evid: 47.
     * Event description: Group ->  Membership Questions - Question Actions.
    
     * action - Type: string. Desc: open/edit/remove/delete/cancel
     *
     * groupId - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: edit_qs_scr_question_area, edit_qs_scr_three_dots, edit_question_modal, delete_question_modal
     *
     * questionId - Type: string. Desc: question ID
     *
     * questionIndex - Type: numeric. Desc: q index
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr
     * @param {groupMembershipQuestionsQuestionActionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupMembershipQuestionsQuestionActions = function (params) {
        return this.bi.log(__assign({ evid: 47 }, params));
    };
    /**
    * @typedef {Object} clubPostOptionsEditEditSavedParams
    * @property {GUID} club_id - null
    * @property {GUID} clubId - null
    * @property {string} container - null
    * @property {string} post_id - null
    * @property {string} postId - null
    * @property {GUID} postItemId - null
    * @property {string} userClass - null
    **/
    /**
     * Name: Club post -> options --> edit -> edit saved. Evid: 146.
    
    
     * club_id - Type: guid.
     *
     * clubId - Type: guid.
     *
     * container - Type: string.
     *
     * post_id - Type: string.
     *
     * postId - Type: string.
     *
     * postItemId - Type: guid.
     *
     * userClass - Type: string.
     * @param {clubPostOptionsEditEditSavedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clubPostOptionsEditEditSaved = function (params) {
        return this.bi.log(__assign({ evid: 146 }, params));
    };
    /**
    * @typedef {Object} groupsSelectGroupTemplateClickParams
    * @property {string} origin - groups_templates_scr
    * @property {GUID} templateId - template id
    * @property {string} templateName - staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
    * @property {string} userEntry - bizmgr/site/editor/oneapp
    **/
    /**
     * Name: Groups -> Select Group Template Click. Evid: 37.
     * Event description: Groups -> Select Group Template Click.
    
     * origin - Type: string. Desc: groups_templates_scr
     *
     * templateId - Type: guid. Desc: template id
     *
     * templateName - Type: string. Desc: staff/education/family/vips/meetup/hobby or custom_group if from Create Custom button
     *
     * userEntry - Type: string. Desc: bizmgr/site/editor/oneapp
     * @param {groupsSelectGroupTemplateClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsSelectGroupTemplateClick = function (params) {
        return this.bi.log(__assign({ evid: 37 }, params));
    };
    /**
    * @typedef {Object} groupActionClickParams
    * @property {string} action - 'share'/'group_settings'/'report'/'leave'/'delete'/'notification_settings'
    * @property {GUID} group_id - group_id
    * @property {string} origin - arrow / menu / button / modal_dialog_button
    * @property {string} userEntry - site / bizmngr
    **/
    /**
     * Name: Group -> group action click. Evid: 4.
     * Event description: clicked group action from three dots.
    
     * action - Type: string. Desc: 'share'/'group_settings'/'report'/'leave'/'delete'/'notification_settings'
     *
     * group_id - Type: guid. Desc: group_id
     *
     * origin - Type: string. Desc: arrow / menu / button / modal_dialog_button
     *
     * userEntry - Type: string. Desc: site / bizmngr
     * @param {groupActionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupActionClick = function (params) {
        return this.bi.log(__assign({ evid: 4 }, params));
    };
    /**
    * @typedef {Object} groupsRequestJoinAGroupParams
    * @property {string} approvalStatus - status of member upon request
    * @property {GUID} groupId - null
    * @property {GUID} group_id - value
    * @property {string} origin - group_feed_top_banner_btn / group_feed_inside_page_btn
    * @property {string} type - null
    * @property {string} userEntry - site / bizmngr
    **/
    /**
     * Name: Groups -> request / join a group. Evid: 564.
    
    
     * approvalStatus - Type: string. Desc: status of member upon request
     *
     * groupId - Type: guid.
     *
     * group_id - Type: guid. Desc: value
     *
     * origin - Type: string. Desc: group_feed_top_banner_btn / group_feed_inside_page_btn
     *
     * type - Type: string.
     *
     * userEntry - Type: string. Desc: site / bizmngr
     * @param {groupsRequestJoinAGroupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupsRequestJoinAGroup = function (params) {
        return this.bi.log(__assign({ evid: 564 }, params));
    };
    /**
    * @typedef {Object} newEventCreateYourGroupPageLoadParams
    * @property {GUID} msid - msid
    **/
    /**
     * Name: Groups->Create your group page load. Evid: 780.
     * Event description: user is viewing create your group page (with form to fill).
    
     * msid - Type: guid. Desc: msid
     * @param {newEventCreateYourGroupPageLoadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.newEventCreateYourGroupPageLoad = function (params) {
        return this.bi.log(__assign({ evid: 780 }, params));
    };
    /**
    * @typedef {Object} groupGroupEventsButtonClicksParams
    * @property {string} buttonName - create_event, discard/back, save
    * @property {number} count - # of events with checks on “save”
    * @property {GUID} groupId - group ID
    * @property {string} name - Settings area name
    * @property {string} origin - group_events_list, group_events_empty_state
    * @property {string} userEntry - oneapp/bizmngr/site
    **/
    /**
     * Name: Group -> Group Events Button Clicks. Evid: 58.
     * Event description: Group -> Group Events Button Clicks.
    
     * buttonName - Type: string. Desc: create_event, discard/back, save
     *
     * count - Type: numeric. Desc: # of events with checks on “save”
     *
     * groupId - Type: guid. Desc: group ID
     *
     * name - Type: string. Desc: Settings area name
     *
     * origin - Type: string. Desc: group_events_list, group_events_empty_state
     *
     * userEntry - Type: string. Desc: oneapp/bizmngr/site
     * @param {groupGroupEventsButtonClicksParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.groupGroupEventsButtonClicks = function (params) {
        return this.bi.log(__assign({ evid: 58 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 111,
        endpoint: 'groups'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map